import React, { Component, Fragment } from 'react';
import GiveMeMoreButton from "../BlogPage/GiveMeMoreButton";
import JobCard from "./JobCard";
import { FormattedMessage } from "react-intl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/pro-light-svg-icons";
import LocaleLink from '../../Routes/LocaleLink'

class JobsPageJobsGrid extends Component {
    handleMore() {
        this.props.handleMore();
    }

    render() {

        const { offers } = this.props;

        if (!offers) return null;

        return (
            <section className="section-job-list">
                <div className="container">
                    <ul className="job-list">
                        {offers && offers.map((offer, key) => {

                            const position = key + 1;

                            return (
                                <Fragment key={key}>
                                    <li>
                                        <JobCard offer={offer} key={offer.id} />
                                    </li>
                                    {(position === 4 && offers.length >= 5) || (offers.length < 5 && position === offers.length) ?
                                        <li>
                                            <LocaleLink to="/candidature-spontanee">
                                                <div className="job-info-block active">
                                                    <h2>
                                                        <FormattedMessage
                                                            id="portfolio.jobs.dream.link"
                                                            defaultMessage="LE JOB DE VOS RÊVES N’EST PAS LISTÉ ? LAISSEZ-NOUS LE TROUVER POUR VOUS"
                                                            values={{ br: <br /> }}
                                                        />&nbsp;!
                                                    </h2>
                                                    <FontAwesomeIcon icon={faArrowRight} />
                                                    &nbsp;
                                                </div>
                                            </LocaleLink>
                                        </li>
                                        : null
                                    }
                                </Fragment>
                            )
                        })}
                    </ul>
                    <GiveMeMoreButton onClick={() => this.handleMore()} loading={this.props.loading} />
                </div>
            </section>
        )
    }
}

export default JobsPageJobsGrid;
